<template>
    <v-btn
        :loading="loadingBtn"
        outlined
        :small="small"
        :disabled="disabled"
        :class="[buttonClass, { 'PrimaryButton': isPrimary,'button-disabled': disabled }]"
        style="padding: 0px;height: 36px;"
        @click="handleClick"
        class="buttonClass"
        
    >
        <v-icon 
        :color="disabled ? '#aaa' : IconColor"
            >{{ icon }}
        </v-icon>
    </v-btn>
</template>

<script>
export default {
name: 'IconButton',
    props: {
        icon: {
            type: String,
            default: 'mdi-pencil'
        },
        buttonClass: {
            type: String,
            default: 'IconButton'
        },
        IconColor: {
            type: String,
            default: 'black'
        },
        disabled: { 
            type: Boolean,
            default: false,
        },
        small: {
          type: Boolean,
          default: false
      },
    // buttonheight: {
    //     type: String,
    //     default: '36px'
    // },
        isPrimary: {
            type: Boolean,
            default: false
        },
        // width: {
        //     type: String,
        //     default: '36px'
        // },
        loading: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        buttonheight() {
            return this.height;
        },
        loadingBtn(){
            return this.loading;
        }
  },
    methods: {
        handleClick() {
            this.$emit('click');
        }
    }
};
</script>

<style scoped>
.buttonClass { 
    background-color: #ffffff;
    border: 1px solid #bbb; 
}
.button-disabled {
  background-color: #f9f9f9;
  border: 1px solid #eee; 
  color: #aaa;
}

.PrimaryButton {
    background: #007bff !important;
    color: #fff;
}
</style>